import React from 'react';
import { Link } from 'react-router-dom';
import './ProductCard.css';

const ProductCard = ({ product, index }) => {
  return (
    <Link
      to={`/products/${product.id}`}
      className="product-card-link-wrapper"
      style={{ textDecoration: 'none' }}
    >
      <div
        className="product-card"
        style={{
          '--card-color': product.color,
          animationDelay: `${index * 0.08}s`
        }}
      >
        <div className="product-card-image">
          {product.image ? (
            <img src={product.image} alt={product.name} />
          ) : (
            <div className="image-placeholder">
              <div className="placeholder-icon">⚙️</div>
              <p>{product.name}</p>
            </div>
          )}
          <div className="card-category-badge">{product.category}</div>
        </div>

        <div className="product-card-body">
          <div
            className="card-accent-line"
            style={{ background: product.color }}
          />
          <p className="card-tagline">{product.tagline}</p>
          <h3 className="card-name">{product.name}</h3>
          <p className="card-desc">
            {product.description.slice(0, 110)}...
          </p>

          {/* <div className="card-spec-preview">
            <div className="spec-chip">
              <span className="spec-key">Capacity</span>
              <span className="spec-val">2-6 TPH</span>
            </div> */}
            <div className="card-spec-preview">
  <div className="spec-chip">
    <span className="spec-key">Capacity</span>
    <span className="spec-val">
      {product.specs.length === 1
        ? product.specs[0].capacity
        : "2-6 TPH"}
    </span>
  </div>


            <div className="spec-chip">
              <span className="spec-key">Power</span>
              <span className="spec-val">{product.hp}</span>
            </div>
          </div>

          <div className="card-link">
            View Details
            <span className="card-link-arrow">→</span>
          </div>
        </div>
      </div>
    </Link>
  );
};

export default ProductCard;